import React from "react";
import { combineDateAndHour } from "venuescanner-js/utils";

const listTimes = () => {
  const op = [];
  for (let i = 0; i < 24; i++) {
    op.push(`${i}`.padStart(2, "0") + ":00");
    op.push(`${i}`.padStart(2, "0") + ":30");
  }
  op.push("23:59");
  return op;
};
export const times = listTimes(); /* [
  const
  ...[...Array(24).keys()].map(i => `${i}`.padStart(2, '0') + ':00'),
  '23:59'
] */

export const getTimeOption = (time) => (
  <option value={time} key={time}>
    {time}
  </option>
);

export const getTimesAfter = (dateAndTime, endDate) =>
  times.filter((timeOption) =>
    dateAndTime.isBefore(combineDateAndHour(endDate, timeOption))
  );
